module.exports = __webpack_public_path__ + "static/media/plusCircleIcon.2405a5f8.svg";